import { ModalContext, ModalContextType } from "modules/modals/src/modal-context"
import { useContext } from "react"

export function useModals (): ModalContextType {
    return useContext( ModalContext )
}
